var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.333,
    height: 32.333,
    viewBox: "0 0 32.333 32.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:none;stroke:#fff;stroke-width:1.5px;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-197.733 -258.448) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 54.363,
    x1: 345.432,
    y1: 31.5,
    x2: 345.432,
    transform: "matrix(0.707107, 0.707107, -0.707107, 0.707107, 131.531754, -231.682897)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 54.365,
    x1: 345.431,
    y1: 31.502,
    x2: 345.431,
    transform: "matrix(-0.70713, 0.707083, -0.707083, -0.70713, 620.053312, -170.955364)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plusWhite.bf18c43ff75798d427aab538e6684435.svg";
export { ForwardRef as ReactComponent };